export default __webpack_public_path__ + "6741aa4389f3e37415c46d1e8d7f937a.png";